export default __webpack_public_path__ + "static/media/img-heatmap-sample.5441bc69.png";